import apiFetch from '../apiFetch'

export default function (dossierTypeId, token) {
  return apiFetch({ endPoint: `DossierType/${dossierTypeId}/Subtypes/All`, method: 'GET', body: null, token: token })
}
